import Loading from 'components/Loading/Loading';
import { FullPageLoaderPriority, FullPageLoaderScope, selectVisibleFullPageLoader, useAppStore } from 'state_management/zustand/appStore';

const DEFAULT_FULL_PAGE_ENTER_DELAY_MS = 150;

const getDefaultEnterDelay = (priority: FullPageLoaderPriority): number => {
  if (priority === 'appBootstrap' || priority === 'projectBootstrap') {
    return 0;
  }

  return DEFAULT_FULL_PAGE_ENTER_DELAY_MS;
};

export const FullPageLoadingHost = ({ scope }: { scope: FullPageLoaderScope }) => {
  const resolvedLoader = useAppStore(selectVisibleFullPageLoader(scope));
  const enterDelay = resolvedLoader ? (resolvedLoader.enterDelay ?? getDefaultEnterDelay(resolvedLoader.priority)) : undefined;

  return (
    <Loading
      show={!!resolvedLoader}
      message={resolvedLoader?.message ?? ''}
      autoId={resolvedLoader?.autoId}
      enterDelay={enterDelay}
      exitDelay={resolvedLoader?.exitDelay}
      isFixedPosition={scope === 'app'}
    />
  );
};
